import React from 'react';

function Icon() {
  return (
    <svg width="97" height="95" fill="none" viewBox="0 0 97 95">
      <path
        fill="url(#paint0_linear_growth)"
        d="M37.41 18.634c-9.01-6.166-24.029-4.267-34.539-2.3a2.007 2.007 0 00-1.603 2.341C3.235 29.19 6.894 43.878 15.9 50.05a18.688 18.688 0 0013.85 2.206 20.012 20.012 0 0012.61-7.157c4.595-6.715 2.991-21.025-4.952-26.464z"></path>
      <path
        fill="#86E1D6"
        d="M87.267 8.619c-10.514 1.967-25.203 5.626-31.374 14.633-5.452 7.962-1.761 21.86 4.95 26.46a20.017 20.017 0 0014.349 2.114 18.693 18.693 0 0012.116-7.065c6.17-9.011 4.267-24.029 2.3-34.543a2.007 2.007 0 00-2.341-1.599z"></path>
      <path
        fill="#52D4C5"
        d="M58.842 94.104A2.007 2.007 0 0156.5 92.5c-7.828-41.838-26.89-55.714-33.405-58.583a15.697 15.697 0 01-2.253-1.126 2.007 2.007 0 012.268-3.311c.516.293 1.052.55 1.605.765 5.785 2.548 19.411 8.553 28.662 34.882A48.091 48.091 0 0173.29 28.004a2.171 2.171 0 012.924.355 1.862 1.862 0 01-.312 2.696l-.291.21C55.887 45.48 57.27 74.86 60.434 91.765a2.007 2.007 0 01-1.592 2.339z"></path>
      <defs>
        <linearGradient
          id="paint0_linear_growth"
          x1="20.681"
          x2="48"
          y1="13.001"
          y2="56"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#7DDFD3"></stop>
          <stop offset="1" stopColor="#DCF6F3"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Icon;
